module.exports = __webpack_public_path__ + "static/media/step-4-book.e41c328a.gif";